import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comMyOrder/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getOrderDetail = query => {  
    var list = request({
        url: 'comOrderDetail/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const downMyOrderExcel = query => {  
    var list = request({
        url: 'comMyOrder/getMyOrderExcel.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
 